import React from 'react';

const SquircleDefs = () => (
  <svg width="0" height="0" style={{ position: 'absolute' }}>
    <defs>
      <clipPath id="squircle-clip" clipPathUnits="objectBoundingBox">
        <path d="M 0.5,0 L 0.85,0 C 0.93,0 1,0.07 1,0.15 L 1,0.85 C 1,0.93 0.93,1 0.85,1 L 0.15,1 C 0.07,1 0,0.93 0,0.85 L 0,0.15 C 0,0.07 0.07,0 0.15,0 Z" />
      </clipPath>
      <clipPath id="custom-clip" clipPathUnits="objectBoundingBox">
        <path id="customPath" d=""></path>
      </clipPath>
      <clipPath id="clip1" clipPathUnits="objectBoundingBox">
        <path id="path1" d="M 0.23333333333333334,0 L 0.7666666666666666,0 C 1,0 1,0 1,0.23333333333333334 L 1,0.7666666666666666 C 1,1 1,1 0.7666666666666666,1 L 0.23333333333333334,1 C 0,1 0,1 0,0.7666666666666666 L 0,0.23333333333333334 C 0,0 0,0 0.23333333333333334,0 Z"></path>
      </clipPath>
      <clipPath id="clip2" clipPathUnits="objectBoundingBox">
        <path id="path2" d="M 0.4,0 L 0.6,0 C 1,0 1,0 1,0.4 L 1,0.6 C 1,1 1,1 0.6,1 L 0.4,1 C 0,1 0,1 0,0.6 L 0,0.4 C 0,0 0,0 0.4,0 Z"></path>
      </clipPath>
      <clipPath id="clip3" clipPathUnits="objectBoundingBox">
        <path id="path3" d="M 0.5,0 L 0.5,0 C 1,0 1,0 1,0.5 L 1,0.5 C 1,1 1,1 0.5,1 L 0.5,1 C 0,1 0,1 0,0.5 L 0,0.5 C 0,0 0,0 0.5,0 Z"></path>
      </clipPath>
      <clipPath id="clip4" clipPathUnits="objectBoundingBox">
        <path id="path4" d="M 0.5,0 L 0.5,0 C 1,0 1,0 1,0.5 L 1,0.5 C 1,1 1,1 0.5,1 L 0.5,1 C 0,1 0,1 0,0.5 L 0,0.5 C 0,0 0,0 0.5,0 Z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default SquircleDefs;
